/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { unsetUserData } from '@/redux/slices/user/actions';

import { AdvertisementState } from './types';

const initialState: AdvertisementState = {
  shouldShowAd: false,
  lastAdWatchedAt: 0,
  sessionCount: 0,
};

const advertisementsSlice = createSlice({
  name: 'advertisements',
  initialState,
  reducers: {
    setShouldShowAdOnNewSession: (state) => {
      state.shouldShowAd = false;
      state.sessionCount += 1;
    },
    flagShouldShowAd: (state, { payload }: PayloadAction<boolean>) => {
      state.shouldShowAd = payload;
    },
    advertisementWatched: (state) => {
      state.shouldShowAd = false;
      state.lastAdWatchedAt = Date.now();
    },
  },
  extraReducers: (builder) => {
    builder.addCase(unsetUserData, () => initialState);
  },
});

export default advertisementsSlice;
